import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  // Legacy meeting rooms redirects
  { path: 'meeting-rooms/meeting-rooms-booking', pathMatch: 'full', redirectTo: 'meeting-room' },
  { path: 'meeting-rooms', pathMatch: 'full', redirectTo: 'meeting-room' },

  {
    path: 'manage-booking',
    loadChildren: () => import('./modules/manage-booking/manage-booking.module').then((m) => m.ManageBookingModule)
  },

  { path: '', loadChildren: () => import('./modules/booking/booking.module').then((m) => m.BookingModule) },

  { path: '**', redirectTo: 'meeting-room' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
